import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Grid, createStyles, withStyles } from '@material-ui/core';
import cx from 'classnames';
import TextFormInput from '../Text';
import Button from '../../../core/Button';
import { InputLabel, FormControl, FormHelperText, Typography } from '@material-ui/core';

var styles = function styles(theme) {
  return createStyles({
    input: {
      '& input': {
        cursor: 'pointer'
      }
    },
    standardButton: {},
    filledButton: {
      height: 41,
      borderLeft: 'none',
      borderColor: theme.palette.divider
    },
    labelSpace: {
      marginTop: theme.spacing(2)
    }
  });
};

var noop = function noop() {};

var FileFormField = function FileFormField(_ref) {
  var value = _ref.value,
      placeholder = _ref.placeholder,
      name = _ref.name,
      variant = _ref.variant,
      disabled = _ref.disabled,
      classes = _ref.classes,
      label = _ref.label,
      onClick = _ref.onClick,
      helperText = _ref.helperText,
      error = _ref.error,
      required = _ref.required,
      margin = _ref.margin,
      rest = _objectWithoutProperties(_ref, ["value", "placeholder", "name", "variant", "disabled", "classes", "label", "onClick", "helperText", "error", "required", "margin"]);

  return React.createElement(FormControl, {
    error: error,
    fullWidth: true,
    required: required,
    margin: margin,
    disabled: disabled
  }, label && React.createElement(InputLabel, {
    variant: variant
  }, React.createElement(Typography, {
    display: "inline",
    color: "inherit"
  }, label)), React.createElement(Grid, {
    container: true,
    alignItems: "flex-end",
    className: _defineProperty({}, classes.labelSpace, label ? true : false)
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(TextFormInput, Object.assign({
    fullWidth: true,
    value: value,
    placeholder: placeholder,
    name: name,
    variant: variant,
    disabled: disabled,
    onChange: noop,
    onClick: onClick,
    className: cx(_defineProperty({}, classes.input, !disabled)),
    error: error
  }, rest))), React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    variant: "outlined",
    color: variant === 'filled' ? 'inherit' : 'default',
    className: classes[variant + 'Button'],
    disabled: disabled,
    onClick: onClick
  }, "Choose"))), helperText && React.createElement(FormHelperText, null, helperText));
};

FileFormField.defaultProps = {
  onClick: noop,
  variant: 'standard'
};
export default withStyles(styles, {
  name: 'ECFileFormField'
})(FileFormField);